import { render } from "./ChangeDealAmountModal.vue?vue&type=template&id=3311974c&ts=true"
import script from "./ChangeDealAmountModal.vue?vue&type=script&lang=ts"
export * from "./ChangeDealAmountModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__